import { apiClient } from '../utils';
import { store } from '../redux/store';
import { showAlert } from '../redux/modules/alert';
import { handleError } from './';

export const editProfile = async ({ nickName }) => {
  try {
    const { result } = await apiClient.post('/user/profile/edit', {
      data: { bn: nickName },
    });
    store.dispatch(
      showAlert(
        'نام و نام خانوادگی حساب شخصی شما با موفقیت ویرایش شد.',
        'success',
        'TOP'
      )
    );
    return result;
  } catch (e) {
    handleError(e);
    return e;
  }
};
